module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "slack.f7fc8c2e.svg";